export const stringifyNumericDisplayOptions = (value) => {
    if (Array.isArray(value)) {
        return value.map(stringifyNumericDisplayOptions);
    }

    if (value && typeof value === 'object') {
        return Object.entries(value).reduce((normalized, [key, optionValue]) => {
            normalized[key] = stringifyNumericDisplayOptions(optionValue);
            return normalized;
        }, {});
    }

    return typeof value === 'number' ? String(value) : value;
};
